module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/am732-e61dc483970636a70a96f8a43173b79d.jpg";